import { Link as LinkMUI, LinkProps as LinkPropsMUI } from "@mui/material";
import React, { forwardRef } from "react";
import { useNavigate } from "react-router";

interface LinkProps extends LinkPropsMUI {
	preserveQueryParams?: boolean;
	disabled?: boolean;
}

const hrefIsRoute = (href: string) => {
	return href.startsWith("/") || href.startsWith("./") || href.startsWith("../");
};

const normalizeHref = (href: string) => {
	const normalizedHref = (href.startsWith("/") ? "/" : window.location.pathname).split("/");
	const fases = href.split("/");

	for (let fase of fases) {
		if (fase === "") {
			continue;
		} else if (fase === ".") {
			normalizedHref.pop();
		} else if (fase === "..") {
			normalizedHref.pop();
			normalizedHref.pop();
		} else {
			normalizedHref.push(fase);
		}
	}

	return normalizedHref.join("/");
};

export const Link: React.FC<LinkProps> = forwardRef<HTMLAnchorElement, LinkProps>(
	({ href, children, onClick, preserveQueryParams, disabled, ...props }, ref) => {
		const navigate = useNavigate();
		const finalHref = href ? href.split("?")[0] : "";
		const queryParams = ((s) => (s.trim() !== "" ? "?" + s : ""))(
			((href?.split("?")[1] ?? "") + (preserveQueryParams ? window.location.search : ""))
				.trim()
				.replace(/\?+/, "")
				.replace(/&+/, "&")
				.replace(/^[\?&]/, "&"),
		);

		const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
			if (disabled) {
				event.preventDefault();
				return;
			}

			if (onClick) {
				onClick(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			if (href && hrefIsRoute(href)) {
				event.preventDefault();
				navigate(normalizeHref(finalHref) + queryParams);
			}
		};

		return (
			<LinkMUI
				ref={ref}
				href={finalHref + queryParams}
				onClick={handleClick}
				{...props}
				{...({ disabled } as any)}
			>
				{children}
			</LinkMUI>
		);
	},
);
